import { MantineProvider } from "@mantine/core";
import { theme } from "./theme";
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import { useRoute } from "react-router5";
import { Recover } from "./components/Recover";

const isDev = !!window.localStorage.getItem("isDev");

function App() {
  const pathURL = window.location.pathname;
  const route = useRoute();
  return (
    <MantineProvider
      theme={theme}
      withCSSVariables
      withGlobalStyles
      withNormalizeCSS
    >
      {pathURL.indexOf("login") > -1 ? (
        <Login isDev={isDev} />
      ) : pathURL.indexOf("register") > -1 ? (
        <Register isDev={isDev} />
      ) : pathURL.indexOf("recover") > -1 ? (
        <Recover isDev={isDev} />
      ) : (
        <Login isDev={isDev} />
      )}
    </MantineProvider>
  );
}

export default App;
